import { Component, Input } from '@angular/core';
import { CmsGlobalReference, CmsStory } from 'src/_model/storyblock';
import { CmsPopupComponent } from "../cms-popup/cms-popup.component";
import { CmsBarComponent } from "../cms-bar/cms-bar.component";
import { NgClass } from '@angular/common';
import { CmsSectionComponent } from "../cms-section/cms-section.component";
import { CmsService } from 'src/_service/CmsService';

@Component({
  selector: 'app-cms-globalreference',
  
  templateUrl: './cms-globalreference.component.html',
  styleUrl: './cms-globalreference.component.scss',
  imports: [
    NgClass,
    CmsPopupComponent, CmsBarComponent,
    CmsSectionComponent
],
})
export class CmsGlobalreferenceComponent {

  stories: CmsStory[] = [];

  private _references: CmsGlobalReference
  @Input() set references (value: CmsGlobalReference){
    //added check if reference is string, happens sometimes in storyblok editor, makes sure that it always shows the global references
    value.reference.forEach((ref, index)=>{
      if(typeof ref !== "string") return;
      console.info('getting reference for uuid: ', ref)
      value.reference[index] = this._cmsService.getReference(ref)
    })
    this._references = value;
    this.stories = this._references.reference
  }

  constructor (
    private _cmsService: CmsService
  ){}

}
